
import {
    onMounted,
    reactive,
    ref,
    defineComponent,
    getCurrentInstance,
} from 'vue'
import { UsePageDto } from '@/common/mixins/listPageDto'
import formatDate from '@/common/functions/formatDate'
import { message, Modal } from 'ant-design-vue'
import { useStore } from 'vuex'
import SetMenu from './components/SetMenu.vue'
import { systemMenu } from './request'

export default defineComponent({
    components: {
        SetMenu,
    },
    setup() {
        const store = useStore()
        const instance = getCurrentInstance()
        const { pagination, listPageDto, handleTableChange } = UsePageDto(
            instance
        )
        const loading = ref<boolean>(false)
        const showLine = ref<boolean>(true)
        const showIcon = ref<boolean>(true)
        let expandedKeys = ref<number[]>([101, 10])
        const replaceFields = {
            children: 'children',
            title: 'name',
            key: 'id',
        }
        const data = ref([])
        const menuData = ref([])
        const onExpand = (keys: number[]) => {
            expandedKeys.value = keys
        }
        async function fetchList() {
            loading.value = true
            try {
                let res = await systemMenu({})
                menuData.value = res.data
                loading.value = false
            } catch (e) {
                loading.value = false
            }
        }
        const configMenuAction = (record: any) => {
            store.commit('setMenuDetail', {
                ...record,
                action: 'mod',
            })
            store.commit('toggleMenuSetMenuState', true)
        }
        function addAction(record: any) {
            store.commit('setMenuDetail', {
                ...record,
                action: 'add',
            })
            store.commit('toggleMenuSetMenuState', true)
        }
        onMounted(() => {
            fetchList()
        })
        return {
            data,
            store,
            configMenuAction,
            formatDate,
            expandedKeys,
            loading,
            menuData,
            showLine,
            onExpand,
            showIcon,
            fetchList,
            replaceFields,
            addAction,
        }
    },
})
